let language = {
    // 产品查询失败
    "CATALOG-SEARCH-LOADING-ISSUE-TITLE": "产品加载异常",
    "CATALOG-SEARCH-LOADING-ISSUE-CONTENT": "加载产品时出现问题。请刷新页面再试一次。如果问题仍然存在，请随时与我们的支持团队联系  {{supportmail}}.",
    "CATALOG-SEARCH-CURRENCY-ISSUE-CONTENT": "当前不支持您首选的货币类型。 请点击页面顶部的\"{{updateCurrencyBtn}}\" 按钮更新货币。",
    A102B3000601: "当前货币: {{currentCurrency}}, {{appName}}平台支持的货币类型：: {{supportCurrencies}}。",
    A102B300310: "系统中不存在货币 {{currentCurrency}}。"
};

export { language }